import posthog from 'posthog-js'

export default {
  install(Vue: any) {
    posthog.init(
      'phc_zgVqQBzIgt6IDCzUK94wRZrG4G502halxnobcYh28Us',
      {
        api_host: 'https://eu.i.posthog.com'
      }
    )
    

    Vue.prototype.$posthog = posthog
    
    // Añadir métodos útiles al prototipo de Vue
    Vue.prototype.$getSessionInfo = function() {
      return {
        sessionId: posthog.get_session_id(),
        sessionReplayUrl: posthog.get_session_replay_url(),
        distinctId: posthog.get_distinct_id(),
        provider: 'posthog'
      }
    }
    
    Vue.prototype.$identifyUser = function(userId: string, userProperties?: any) {
      posthog.identify(userId, userProperties)
    }
  }
} 